import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class TransactionStackItem extends EquatableKeyStackItem {
    asTransaction() {
        return this.value;
    }
}

//# sourceMappingURL=TransactionStackItem.js.map
